<div class="flex bg-surface-switch-0">
  <div
    class="w-full md:w-6/12 px-12 py-20 md:px-20 flex flex-col gap-8 min-h-160 justify-center"
  >
    <div>
      <p-tag severity="danger" value="403"></p-tag>
    </div>
    <div class="flex flex-col gap-4">
      <h1 class="text-5xl font-bold text-surface-switch-900 leading-tight">
        Access Forbidden
      </h1>
      <p class="text-lg text-surface-switch-500 leading-normal">
        Sorry, you don't have permission to access this resource.
      </p>
    </div>
    <div class="flex items-center gap-6">
      <button
        pButton
        [text]="true"
        class="text-base! leading-normal!"
        (click)="goBack()"
      >
        <i pButtonIcon class="pi pi-arrow-left"></i>
        <span pButtonLabel>Go Back</span>
      </button>
      @if (userService.user()) {
        <button pButton class="text-base! leading-normal!" (click)="logout()">
          <i pButtonIcon class="pi pi-sign-out"></i>
          <span pButtonLabel>Logout</span>
        </button>
      } @else {
        <button
          pButton
          class="text-base! leading-normal!"
          (click)="redirectToLogin()"
        >
          <i pButtonIcon class="pi pi-sign-in"></i>
          <span pButtonLabel>Login</span>
        </button>
      }
    </div>
  </div>
  <div
    class="w-full md:w-6/12 hidden md:block"
    style="
      background:
        linear-gradient(
          0deg,
          var(--p-primary-500) 0%,
          var(--p-primary-500) 100%
        ),
        url(&quot;https://fqjltiegiezfetthbags.supabase.co/storage/v1/object/public/block.images/blocks/pagenotfound/pagenotfound-split.jpg&quot;)
          lightgray 50% / cover no-repeat;
      background-blend-mode: overlay, normal;
    "
  ></div>
</div>
